// extracted by mini-css-extract-plugin
export default {"root":"NoContent_root__i-szx","cactus":"NoContent_cactus__VTQXX"};